jQuery(document).ready(function($) {
  var thumbnailProductGallery = $(".product_section .product_gallery_nav");  // set variable for thumbnail gallery.

  // function to detect if user device is iOS device
  function iOS() {
    return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
    // iPad on iOS 13 detection
    || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  }

  function productGallery() {
    // Initialize thumbnail gallery slider.

    
    if($(window).width() >= 768){
    // Product main images gallery init function.
    var initProductMainGallery = function() {
      $(".product_gallery").flickity({
        pageDots: false,
        freeScroll: false,
        wrapAround: true,
        arrowShape: {
          x0: 10,
          x1: 60, y1: 50,
          x2: 65, y2: 45,
          x3: 20
        }
      });
    }
    } else if($(window).width() <= 767){
     var initProductMainGallery = function() {
      $(".product_gallery").flickity({
        pageDots: false,
        freeScroll: false,
        dragThreshold: 3,
        setGallerySize: false,
        friction: 0.8,
        selectedAttraction: 0.2,
        wrapAround: true,
        prevNextButtons: true,
        resize: false
      });

      // fixes known issue with Flickity on newer iOS devices
      // issue: https://github.com/metafizzy/flickity/issues/959
      // fix: https://gist.github.com/bakura10/b0647ef412eb7757fa6f0d2c74c1f145
      if (iOS) {
        (function() {
          var touchingCarousel = false,
            touchStartCoords;
      
          document.body.addEventListener('touchstart', function(e) {
            if (e.target.closest('.product_gallery, .ridge-pdp-slider-carousel')) {
              touchingCarousel = true;
            } else {
              touchingCarousel = false;
              return;
            }
      
            touchStartCoords = {
              x: e.touches[0].pageX,
              y: e.touches[0].pageY
            }
          });
      
          document.body.addEventListener('touchmove', function(e) {
            if (!(touchingCarousel && e.cancelable)) {
              return;
            }
      
            var moveVector = {
              x: e.touches[0].pageX - touchStartCoords.x,
              y: e.touches[0].pageY - touchStartCoords.y
            };
      
            if (Math.abs(moveVector.x) > 7)
              e.preventDefault()
      
          }, {passive: false});
        })();
      }
    }   
  }

    // Product thumbnails init function.
    var initProductThumbnail = function() {
      thumbnailProductGallery.each(function() {
        $(this).flickity({
          cellAlign: 'center',
          contain: true,
          adaptiveHeight: true,
          initialIndex: 0,
          setGallerySize: false,
          lazyLoad: 'true',
          imagesLoaded: true,
          pageDots: false,
          prevNextButtons: false,
          asNavFor: `.product_gallery[data-alt='${this.dataset.alt}']`, // Connect the thumbnail gallery and main product gallery based proper selectors
          freeScroll: true,
          wrapAround: false,
          arrowShape: {
            x0: 10,
            x1: 60, y1: 50,
            x2: 70, y2: 40,
            x3: 30
          }
        });
        
		if(window.matchMedia('(min-width: 1024px)').matches) {
          $(this).find('.flickity-viewport').height(200);
        } else {
          $(this).find('.flickity-viewport').height(100);
        }
      })
    }

    initProductMainGallery();
    initProductThumbnail();
    
        
    if(window.matchMedia('(min-width: 1024px)').matches) {
      thumbnailProductGallery.style.marginTop = '-3rem';
    }
  }

//   const loader = $('.loading-container');
//   let firedOnce = false;
  
//   $(".product_gallery").one('lazybeforeunveil', e => {
//     // only want the following to fire once
//     if(!firedOnce) {
//       // initialize product galleries
//       productGallery();

//       // fire swatch event handlers for initial page load
//       // $(".swatch .wk_boxvariant").eq(0).find("label").trigger("click");
//       // $(".swatch_options input:checked+.swatch-element label").trigger("click");
//       firedOnce = true;
//     }
    
//     // check if the first image in the carousel has fully loaded
//     const firstImgInCarousel = e.currentTarget.querySelector('img')
//     firstImgInCarousel.onload = () => {
//       // hide loader after showing images (setTimeout for when element changes height)
//       setTimeout(() => {
//         const productSection = document.querySelector('.section.product_section');
//         const productImgColumn = document.querySelector('.nine.columns.alpha');
//         const galleryWrap = document.querySelector('.gallery-wrap');
//         const activeThumbnailCarousel = document.querySelector('.product_gallery_nav:not(.hide)');
//         const mobileWrap = document.querySelector('.nine.columns.alpha');

//         if(window.innerWidth <= 767) {
//           mobileWrap.style.minHeight = `${galleryWrap.offsetHeight}px`;
//         } else {
//           // set a min-height on container to prevent unloaded image from moving other elements around too much
//           productSection.style.minHeight = `${galleryWrap.offsetHeight}px`;
//           productImgColumn.style.minHeight = `${galleryWrap.offsetHeight}px`;
//         }


// //         loader.hide();

//         // for wallets, we want to move the thumbnail gallery a little bit close to the main nav
//         if(activeThumbnailCarousel.classList.contains('is-wallet')) {
//           if(window.matchMedia('(min-width: 1024px)').matches) {
//             activeThumbnailCarousel.style.marginTop = '-3rem';
//           }
//         }

//       }, 0)
//     }
//   });

  // Show/hide gallery slider when click swatch button.
  
  $(".wk_boxvariant label").on("click", function(e) {
//     setTimeout(function() {
//       const currentScrollPosition = document.documentElement.scrollTop;
//       var sel_radios = $(".wk_boxvariant.style_radios input[type='radio']:checked");	// Get Variant selected options. This is for composing alt text.
//       var swatch_text = '';
      
//       for ( var i = 0; i < sel_radios.length; i ++ ) {
//         // Filter only valid ones.
//         if(sel_radios.eq(i).parent().find(".swatch-element").attr("data-value") == null || sel_radios.eq(i).parent().find(".swatch-element").attr("data-value") == 'undefined'){
//           break;
//         }

//         if(i > 0) {
//           swatch_text += '+';
//         }
//         swatch_text += sel_radios.eq(i).parent().find(".swatch-element").attr("data-value");  //Get Swatch Text. We need this forloop in case when product has several swatches (color, size, ...).
//       }

//       const activeCarousel = $(".product_gallery[data-alt='" + swatch_text + "']");
//       const activeThumbnailCarousel = $(".product_gallery_nav[data-alt='" + swatch_text + "']");

//       // check if the carousel has already been lazyloaded
//       if(!activeCarousel.find('img').eq(0).hasClass('lazyloaded')) {
//         console.log('not lazyloaded');
//         //loader.show();
//       }

//       $(".product_gallery").addClass("hide");
//       activeCarousel.removeClass("hide");	// Hide all product_gallery divs and only show one that has the same alt text.
//       activeCarousel.flickity('resize');		// Refresh flickity slider so images loaded properly.
//       $(".product_gallery_nav").addClass("hide");
//       activeThumbnailCarousel.removeClass("hide");	// Hide all product_gallery_nav divs and only show one that has the same alt text.
//       activeThumbnailCarousel.flickity('resize');		// Refresh flickity slider so images loaded properly.

//       $(".product_gallery_nav").flickity( 'select', 0 );       // Init all carousel indexes to 0.

//       // prevent flickity resize function from scrolling back to top
//       document.documentElement.scrollTop = currentScrollPosition;
//     }, 0);
  });


  // Mobile swatch select
  $(".wk_boxvariant label").on("touchstart", function(e) {
    $(this).trigger("click");
  });

  // fire swatch event handlers for initial page load
  productGallery();
  $(".swatch_options input:checked+.swatch-element label").trigger("click");
}); 